import Sprite from "./Sprite";
import {
  PLACEMENT_TYPE_CIABATTA,
  PLACEMENT_TYPE_ENEMY,
  PLACEMENT_TYPE_FLYING_ENEMY,
} from "../../helpers/consts";
import { TILES } from "../../helpers/tiles";

const getTile = (enemyType, direction) => {
  if (enemyType === PLACEMENT_TYPE_ENEMY) {
    const map = {
      LEFT: TILES.ENEMY_LEFT_SPAWN,
      RIGHT: TILES.ENEMY_RIGHT_SPAWN,
      UP: TILES.ENEMY_UP_SPAWN,
      DOWN: TILES.ENEMY_DOWN_SPAWN,
    };
    return map[direction];
  }
  if (enemyType === PLACEMENT_TYPE_FLYING_ENEMY) {
    const map = {
      LEFT: TILES.ENEMY_FLYING_LEFT_SPAWN,
      RIGHT: TILES.ENEMY_FLYING_RIGHT_SPAWN,
      UP: TILES.ENEMY_FLYING_UP_SPAWN,
      DOWN: TILES.ENEMY_FLYING_DOWN_SPAWN,
    };
    return map[direction];
  }
  if (enemyType === PLACEMENT_TYPE_CIABATTA) {
    return TILES.CIABATTA_SPAWN;
  }

  return TILES.ENEMY_ROAMING_SPAWN;
};

export default function EnemySpawn({ enemyType, direction }) {
  return <Sprite frameCoord={getTile(enemyType, direction)} />;
}
